export const MaxappsDark = {
  themeName: "MaxappsDark",
  isDark: false,
  CardViewBgColor: "#f1eef6bb",
  connectBtn: "#222222",
  label: "#A884FF",
  loader: "#EFBF00",
  headerColor: "#222222",
  offline: "#ec4545",
  offlineLabel: "#838383",
  primaryColor: "#515050B2",
  welcomeBg: "#CBDBDF",

  textColor: "#F3F3F3",
  labelColor: "#8A8A8A",
  listBg: "#1F2129",

  settingCollapseColor: "#eee",
  separatorColor: "#aaa",

  fapMap: "#aaa",
  danger: "#EE6E6E",
  warning: "#e59d4b",
  welcomeBg: "#D7E3E3",
  success: "#3ecd7e",
  playerControl: "#FFFFFF30",
  whiteToast: "#FFF",
  blazeOrangeToast: "#FE6301",
  mantisToast: "#69C779",
  altoToast: "#D8D8D8",
  dustyGrayToast: "#979797",
  infoToast: "#6FFFDC",
  yellowToast: "#edc300",
  greyToast: "#ccc",
  grayToast: "#aaa",
  lightToast: "#e5e2ec",
  appBg: "#f8f8f8",
  appBorder: "#e7e7e7",
  groupIcon: "#ffffff",

  borderRecord: "#51505040",
  borderFormInput: "#707073",
  swipableBg: "#ffffff",
  landingScreenModeBg: "#F3F3F3",
  calenderBorder: "#CBDBDF",
  cancelButton: "#404147",
  listPlaceHolder: "#eee",
  fapMapBg: "#ffffff",
  fapMapActive: "#222222",
  listBgCard: "#eee",
  noItemToDisplay: "#ccc",
  listItem: "#ffffff",
  linkColor: "#1D9BF0",
  colorTextInput: "#222222",
  LogincolorTextInput: "#222222",
  headerPrimary: "#22222200",
  headerDark: "#29292900",
  headerText: "#F3F3F3",

  //notification colors
  //1
  notificationUpColor: "#F7F8FD",
  notificationDownColor: "#EAEDFA",
  //2
  listItemNotificationDownColor: "#F2F4FC",
  listItemNotificationUpColor: "#E2E5F9",
  //3
  listItemOfflineUpColor: "#FFFFFF",
  listItemOfflineDownColor: "#EAEDFA",

  SelectedDrawerItem: "#333333",

  //login text input
  //bg colors
  bgLoginInput: "#1F2129",
  //border colors
  notfocusedBorderLoginInput: "#707073",
  focusedBorderLoginInput: "#A884FF",
  //label colors
  focusedLabelLoginInput: "#A884FF",
  notFocusedLabelInput: "#707073",
  loginText: "#F3F3F3",
  LogincolorLabelInput: "#707073",
  //icons colors
  resetInputLogin: "#A884FF",

  containerLanguageIcon: "#ffffff00",

  loginFooter: "#F3F3F3",
  loginBgFooter: "#1F2129",
  languageIcon: "#A884FF",
  loginOptions: "#F3F3F3",

  //connect button colors
  bnConnect: "#A884FF",
  loginBtnLabel: "#ffffff",
  shadowBtnConnect: "#22222222",

  //app colors
  iconAppItem: "#A884FF",
  AppText: "#F3F3F3",

  //primary colors
  primary: "#A884FF",
  primaryDark: "#0A1A6B",
  primaryLight: "#A884FF40",

  //secondary colors
  secondary: "#EFBF00",
  secondaryLight: "#EFBF0080",

  //Costum4
  loginFirstTabTitle: "#222",
  loginTabTitle: "#222",
  loginTabSelected: "#fff",
  loginTabNotSelected: "#ffffff4d",

  //CustomLanguge Modal
  languageContainerLeft: "#fff",
  languageContainerRight: "#EFBF00",
  submitLeftConnect: "#222",
  submitRightConnect: "#fff",
};
